namespace('IO.Views.UserGroups', function (exports) {
  'use strict';

  exports.New = IO.Views.UserGroups.Show;
});
